/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Image type enum for tile poster images.
 * Each value maps to a specific API imagetype query parameter
 * accepted by the image-host service.
 */
export type TImageType =
  | "MOVIE"
  | "EPISODE"
  | "SPORTS"
  | "TEAM"
  | "COLLECTION"
  | "GALLERY_TILE"
  | "PARTNER_LOGO";

/**
 * Mapping from TImageType to the API `imagetype` query parameter value
 * expected by the image-host service (/images endpoint).
 */
export const IMAGE_TYPE_API_MAP: Record<TImageType, string> = {
  MOVIE: "moviePoster",
  EPISODE: "seriesBanner",
  SPORTS: "episodeBanner",
  TEAM: "teamBanner",
  COLLECTION: "showcaseBanner",
  GALLERY_TILE: "galleryTile",
  // Streaming-provider / app branding, keyed by a `tivo:pt.*` partner id
  // rather than by a content id — the same image type the Guide uses for an
  // app-linear channel's source logo (ChannelsInteractor.getAppBasedIconUrl).
  PARTNER_LOGO: "partnerSourceLogo"
};
